import React, { useEffect } from "react";

import ContactFooter from "../components/ContactFooter";
import Hero from "../components/Hero";
import { globalActions } from "../reducers/globalActions";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

const SuccessPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const heroData = {
    image: "hero-home.png",
    title: t("success_page.title"),
    subtitle: t("success_page.subtitle"),
    link: "/",
    linkName: t("success_page.linkName"),
  };

  useEffect(() => {
    //ciscenje korpe na frontu
    dispatch(globalActions.dataCartInfo([]));
    dispatch(globalActions.dataCartItemsInfo([]));
    localStorage.removeItem("cart");
  }, [dispatch]);

  return (
    <div className="home-holder-content">
      <div className="container">
        <Hero data={heroData} />
        <ContactFooter />
      </div>
    </div>
  );
};

export default SuccessPage;
